const SPACE_KEY_PREFIX = 'space:';
export function toSpaceKey(spaceSlug) {
    return `${SPACE_KEY_PREFIX}${spaceSlug}`;
}
export function toSpaceSlug(spaceKey) {
    return spaceKey.slice(SPACE_KEY_PREFIX.length);
}
export function isSpaceKey(value) {
    return value.startsWith(SPACE_KEY_PREFIX);
}
